import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import { motion } from 'motion/react';
import PageNavbar from './PageNavbar';
import Footer from './Footer';
import ScrollReveal from './ScrollReveal';
import { getRevealProps, staggerContainer, staggerItem, defaultViewport } from '../motion/scrollMotion';
import { blogPosts } from '../config/blogPosts';
import './ContentPages.css';

// Category tabs are derived from the real articles, in first-seen order.
const categories = ['All', ...blogPosts.reduce((acc, post) => {
  if (!acc.includes(post.tag)) acc.push(post.tag);
  return acc;
}, [])];

const ResourcesPage = () => {
  const [active, setActive] = useState('All');
  const posts = active === 'All' ? blogPosts : blogPosts.filter((p) => p.tag === active);

  return (
    <div className="content-page">
      <PageNavbar />

      <section className="content-hero">
        <div className="content-hero-background" />
        <div className="content-hero-stars" />
        <ScrollReveal className="content-hero-inner" animateOnMount variant="fadeUp">
          <span className="content-badge">Resources</span>
          <h1 className="content-hero-title">
            Insights, Guides &amp; <span className="content-accent">Playbooks.</span>
          </h1>
          <p className="content-hero-desc">
            One library of expert-written articles and practical guides from our security, IT,
            and engineering teams — to help you strengthen defenses and modernize operations.
          </p>
        </ScrollReveal>
      </section>

      <section className="content-section alt">
        <div className="content-container">
          <motion.div className="content-section-header" {...getRevealProps('fadeUp')}>
            <span className="content-section-tag">Resource Library</span>
            <h2 className="content-section-title">Browse our latest resources</h2>
            <p className="content-section-subtitle">
              Deep dives on cybersecurity, compliance, SOC operations, cloud security, managed IT,
              and secure development.
            </p>
          </motion.div>

          {/* Category filter */}
          <div className="resource-filters">
            {categories.map((cat) => (
              <button
                key={cat}
                type="button"
                className={`resource-filter ${active === cat ? 'active' : ''}`}
                onClick={() => setActive(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          <motion.div
            key={active}
            className="content-grid"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={defaultViewport}
          >
            {posts.map((post) => (
              <motion.article key={post.slug} className="content-card" variants={staggerItem}>
                <div className="content-meta">{post.tag} · {post.date}</div>
                <h3 className="content-card-title">{post.title}</h3>
                <p className="content-card-desc">{post.excerpt}</p>
                <Link to={`/blog/${post.slug}`} className="content-card-link blog-read-btn">
                  Read article <FaArrowRight />
                </Link>
              </motion.article>
            ))}
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ResourcesPage;
